export type TimelineEntry = {
  year: string
  title: string
  description: string
}

export const biography = {
  summary:
    'Adebayo Sanni Bello is an engineer, industrialist and former two-term Governor of Osun State. He has spent thirty years building things that had to work — factories, balance sheets and, latterly, a state government that owed its workers eleven months of salaries when he took office.',
  earlyLife:
    'Born in Ilesa in 1966 to a schoolteacher and a textile trader, he attended government schools before winning a federal scholarship to study mechanical engineering at Ahmadu Bello University, Zaria — the four years that gave him both a profession and a lifelong network across northern Nigeria.',
  education:
    'B.Eng Mechanical Engineering, Ahmadu Bello University, Zaria (1988). MBA, Lagos Business School (1996). Fellow, Nigerian Society of Engineers.',
  professional:
    'He began on the factory floor of a cement plant in Sagamu, then spent a decade in industrial finance before founding Bello Agro-Industries in 2003, building four regional processing plants and an out-grower network of 22,000 smallholder farmers.',
  publicService:
    'Appointed Managing Director of the Nigerian Industrial Development Bank in 2011, he published the institution’s full loan book for the first time in its history. He was elected Governor of Osun State in 2015 and served two terms.',
  philosophy:
    'His governing philosophy is unglamorous and specific: publish the target, name the officer responsible, report the result on time, and accept the consequences when it is missed.',
}

export const values = [
  {
    title: 'Say the number',
    description:
      'Every commitment in this campaign carries a figure and a date. Ambition without arithmetic is not a plan.',
  },
  {
    title: 'One Nigeria, one standard',
    description:
      'A clinic in Yobe and a clinic in Lagos are held to the same published standard, or the standard means nothing.',
  },
  {
    title: 'Deliver, then announce',
    description:
      'Commissioning ceremonies are not outcomes. The record is what is still working three years later.',
  },
  {
    title: 'Accountability is a habit',
    description:
      'Independent audit, published data and a scorecard every hundred days — including the parts that fail.',
  },
]

export const timeline: TimelineEntry[] = [
  {
    year: '1988',
    title: 'Graduates in mechanical engineering, ABU Zaria',
    description:
      'Leaves Zaria for national service in Bauchi, teaching mathematics at a rural secondary school.',
  },
  {
    year: '1994',
    title: 'Plant manager, Sagamu cement works',
    description:
      'Cuts unplanned downtime by half in eighteen months by rebuilding the maintenance regime.',
  },
  {
    year: '2003',
    title: 'Founds Bello Agro-Industries',
    description:
      'Four regional cassava and maize processing plants, built to buy from smallholders at a guaranteed price.',
  },
  {
    year: '2011',
    title: 'Managing Director, Nigerian Industrial Development Bank',
    description:
      'Publishes the loan book, introduces independent credit review and cuts non-performing loans from 38% to 9%.',
  },
  {
    year: '2015',
    title: 'Elected Governor of Osun State',
    description:
      'Inherits eleven months of unpaid salaries and a collapsed revenue base.',
  },
  {
    year: '2019',
    title: 'Re-elected with a rebuilt fiscal base',
    description:
      'Internally generated revenue up 4.1x; salaries paid on or before the 25th every month.',
  },
  {
    year: '2023',
    title: 'Leaves office',
    description:
      '1,240 classrooms rebuilt, 312 primary healthcare centres revitalised, and a published handover audit.',
  },
  {
    year: '2026',
    title: 'Declares for the presidency',
    description:
      'Announces a campaign built on published targets and an independently verified 100-day scorecard.',
  },
]

export const gallery = [
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/93340211-d03b-4760-9807-29ce94192f52.jpg',
    alt: 'A community town hall meeting with citizens listening',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/e8e04d27-df9c-4881-b697-26bf91fc9f04.jpg',
    alt: 'Young farmers working a mechanised field',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/db019d07-84c7-4add-8953-0634ea68b0d3.jpg',
    alt: 'Students in a well equipped classroom',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/bd5404b8-d7a4-46e6-9892-2f8d1b841d5a.jpg',
    alt: 'Software developers collaborating in a Lagos technology hub',
  },
]
